import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class DatawallPopupFullComponent extends PopupInnerModalComponent<PopupData.None> {
	<template>
		<div class="content">
			<CommonUiIconComponent @name="AlertFill" @size="2xl" />
			<h3>Your dashboard is already full</h3>
			<p>
				If you would like to add a new datablock to this dashboard you must first delete one
				of the existing datablocks to make space for new. You may also create a new
				dashboard and add up to 32 datablocks to it.
			</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent @text="Close" @onTrigger={{this.close}} />
				</div>
			</div>
		</div>
	</template>
}
